import React, { useState } from 'react'
import {useHistory } from 'react-router-dom';

/**
 * component to render drop down for selecting masters and activity popup 
 * @param {string} activeTab - current tab
 * @returns {JSX.Element}
 */
const MasterDropdown = ({ activeTab, selectedOrg, setSelectedOrg, orgList, isOrgLevel, setSkipactive, canedit, canUpdate, checkActionPermission }) => {
    const [showMaster, setShowMaster] = useState(activeTab);
    const history = useHistory();

    /**
     * function to redirect user to selected masters
     * @param {Array<Object>} value - selected value
     */
    const masterDropdown = (value) =>{
        setShowMaster(value)
        if(value === "route-master" ){
            history.push({pathname:'/companyprofilenew/masters/routemaster'})
        }else if(value === "material-master"){
            history.push({pathname:'/companyprofilenew/masters/materialmaster'})
        }
    }
  return (
    <>
    <div className={`row px-3 col-md-12 mb-2 mt-0`}>
                <div className="col-md-12 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <label className="mb-0 mr-1" style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>Select Masters:</label>
                        <select
                            className={`form-control`}
                            style={{ maxWidth: '200px' }}
                            value={showMaster}
                            onChange={(e) => masterDropdown(e.target.value)}
                        >
                            <option value='material-master'>Material Master</option>
                            <option value="route-master">Route Master</option>
                        </select>

                        {isOrgLevel === true && <select
                            className="form-control ml-3"
                            style={{ maxWidth: "max-content" }}
                            value={selectedOrg}
                            onChange={(e) => {
                                setSelectedOrg(e.target.value);
                                setSkipactive(0)
                            }}
                        >
                            <option value={"company"} selected>Company</option>
                            {
                                orgList && orgList.length > 0 &&
                                orgList.map(item => {
                                    return (
                                        <option value={item.id} key={item.id} >{item.name}</option>
                                    )
                                })
                            }
                        </select>}
                    </div>
                </div>
            </div>
    </>
    )
}

export default MasterDropdown
